export const auditType = {
  GeneralRiskAssessment: 0,
  WorkplaceInspection: 1,
  FireRiskAssessment: 2,
  ConstructionSiteAudit: 3,
  FoodSafetyAudit: 4,
  EqualityActAccessAudit: 5,
  CausewayCharitableServices: 6,
  JephsonsShopFitters: 7,
  CareHomes: 8,
  NUPAS: 9,
  SignsExpress: 10,
  MungoFoundation: 11
}

const auditTypeDescription = {
  [auditType.GeneralRiskAssessment]: "General Risk Assessment",
  [auditType.WorkplaceInspection]: "Workplace Inspection",
  [auditType.FireRiskAssessment]: "Fire Risk Assessment",
  [auditType.ConstructionSiteAudit]: "Construction Site Audit",
  [auditType.FoodSafetyAudit]: "Food Safety Audit",
  [auditType.EqualityActAccessAudit]: "Accessibility Audit",
  [auditType.CausewayCharitableServices]: "Causeway Charitable Services",
  [auditType.JephsonsShopFitters]: "Jephsons Shop Fitters",
  [auditType.CareHomes]: "Care Homes",
  [auditType.NUPAS]: "NUPAS",
  [auditType.SignsExpress]: "Signs Express",
  [auditType.MungoFoundation]: "The Mungo Foundation"
}

export const getAuditTypeDescription = (auditType) => auditTypeDescription[auditType];